import { Zap, Users, Clock, Loader2 } from "lucide-react";

const CARD_HEIGHT = 218;

// Web port of the mobile HeroReceiptScanner. Purple gradient hero card
// with a horizontal scan-line that sweeps top→bottom on a loop, evoking
// the OCR pass. The whole card is one big button.
export default function HeroReceiptScanner({ onPress, scanning = false }) {
  return (
    <button
      type="button"
      data-testid="hero-scan-receipt-btn"
      onClick={onPress}
      disabled={scanning}
      aria-label="Scan a receipt with AI to split a bill"
      className="group relative block w-full overflow-hidden text-left rounded-[22px] border border-white/[0.14] transition-transform duration-200 active:scale-[0.98] hover:brightness-[1.05] disabled:cursor-not-allowed"
      style={{
        height: CARD_HEIGHT,
        background: "linear-gradient(135deg, #6d28d9 0%, #7c3aed 45%, #a855f7 100%)",
      }}
    >
      {/* Top gloss */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0"
        style={{
          height: CARD_HEIGHT * 0.55,
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.28), rgba(255,255,255,0.04), transparent)",
        }}
      />

      {/* Sweeping scan-line */}
      <div
        aria-hidden
        className="hp-scan-line pointer-events-none absolute inset-x-0 top-0"
        style={{ height: 6, "--hp-scan-travel": `${CARD_HEIGHT - 6}px` }}
      >
        <div
          style={{
            height: 6,
            background:
              "linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.65), rgba(255,255,255,0.95), rgba(255,255,255,0.65), rgba(255,255,255,0))",
            boxShadow: "0 0 14px 2px rgba(255,255,255,0.55)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative flex h-full flex-col justify-between p-[18px] pr-11">
        {scanning ? (
          <div className="flex h-full flex-col items-start justify-center gap-2">
            <div className="flex items-center gap-2 text-white">
              <Loader2 className="animate-spin" size={22} />
              <span className="text-2xl font-black tracking-tight">Reading receipt…</span>
            </div>
            <span className="text-[12.5px] text-white/85">Our AI is pulling out the items.</span>
          </div>
        ) : (
          <>
            <div>
              <h3 className="text-2xl font-black tracking-tight text-white">Scan a receipt</h3>
              <p className="mt-0.5 max-w-[260px] text-[12.5px] leading-[17px] text-white/85">
                Point your camera at any receipt. AI reads it and splits the bill.
              </p>
            </div>

            <div className="flex flex-wrap gap-1.5">
              <span className="inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-white/20 bg-white/[0.16] px-2 py-1 text-[10.5px] font-bold text-white">
                <Zap size={12} /> Tax from receipt
              </span>
              <span className="inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-white/20 bg-white/[0.16] px-2 py-1 text-[10.5px] font-bold text-white">
                <Users size={12} /> Assign per person
              </span>
              <span className="inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-white/20 bg-white/[0.16] px-2 py-1 text-[10.5px] font-bold text-white">
                <Clock size={12} /> Under 15 sec
              </span>
            </div>
          </>
        )}
      </div>
    </button>
  );
}
